<template>
  	<FlexPromotionMonitoringReport />
</template>

<script>

// @ is an alias to /src
import FlexPromotionMonitoringReport from "@/components/reports/Flex/PromotionMonitoringReport.vue";

export default {
  name: "FlexPromotionMonitoringReportView",
  components: {
    FlexPromotionMonitoringReport,
  },
};
</script>
